<script lang="ts">
    import { onMount } from 'svelte'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZinputTitle from '../_common/z/zinput-title.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZinputBreak from '../_common/z/zinput-break.svelte'
    import Zframe from '../_common/z/zframe.svelte'

    export let person: Person

    let genderReplace = []
    genderReplace.push({ original: 'male', replace: 'masculino' })
    genderReplace.push({ original: 'female', replace: 'feminino' })
    genderReplace.push({ original: 'other', replace: 'outro' })

    let loaded = false
    onMount(() => {
        console.log('remount', person.name, person.born)
        loaded = true
    })

    let genderOptions = []
    genderOptions.push({ value: 'male', label: 'Masculino' })
    genderOptions.push({ value: 'female', label: 'Feminino' })
    genderOptions.push({ value: 'other', label: 'Não informado' })
</script>

<div class="pt-home">
    {#if loaded}
        <Zframe title="Início">
            <ZContainer>
                <ZinputTitle title="Dados Básicos" label=""></ZinputTitle>
                <Zinput label="Nome do contato" sizeM={12} size={6} type="text" disabled={true} required={true} value={person.name}></Zinput>
                <Zinput label="Celular" sizeM={12} size={6} type="text" disabled={true} value={person.phone}></Zinput>
                <Zinput label="E-Mail" sizeM={12} size={6} type="text" disabled={true} value={person.email}></Zinput>
                <Zinput label="Origem" sizeM={12} size={6} type="text" disabled={true} value={person.referral?.label}></Zinput>
                {#if person.businessName}
                    <Zinput label="Nome da Empresa" sizeM={12} size={6} type="text" disabled={true} value={person.businessName}></Zinput>
                    <ZinputBreak></ZinputBreak>
                {/if}

                <ZinputTitle title="Endereço do cliente" label=""></ZinputTitle>
                <Zinput label="Endereço" sizeM={12} size={6} type="text" value={person.address} disabled={true}></Zinput>
                <Zinput label="Nº" sizeM={12} size={3} type="text" value={person.number} disabled={true}></Zinput>
                <Zinput label="Complemento" sizeM={12} size={3} type="text" value={person.complement} disabled={true}></Zinput>
                <Zinput label="Bairro" sizeM={12} size={4} type="text" value={person.district} disabled={true}></Zinput>
                <Zinput label="Cidade" sizeM={12} size={4} type="text" value={person.city} disabled={true}></Zinput>
                <Zinput label="UF" sizeM={12} size={2} type="text" value={person.state} disabled={true}></Zinput>
                <Zinput label="CEP" sizeM={12} size={2} type="text" value={person.CEP} disabled={true}></Zinput>

                <ZinputTitle title="Dados Pessoais" label=""></ZinputTitle>
                <Zinput label="CPF / CNPJ" sizeM={12} size={3} type="text" value={person.document} disabled={true}></Zinput>
                <Zinput label="RG" sizeM={12} size={3} type="text" value={person.RG} disabled={true}></Zinput>
                <Zinput label="Nascimento" sizeM={12} size={3} type="date" value={person.born} disabled={true}></Zinput>
                <Zinput label="Sexo" sizeM={12} size={3} type="select" options={genderOptions} value={person.gender} disabled={true}></Zinput>

                <Zinput label="Anotações" sizeM={12} size={12} type="text" value={person.comments} disabled={true}></Zinput>
            </ZContainer>
        </Zframe>
    {/if}
</div>
